/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：619
 */

module.exports = {
  dataViewerGrid: "GridDialog_dataViewerGrid__3V352",
  gridName: "GridDialog_gridName__3jASp",
  gridNameEditorContainer: "GridDialog_gridNameEditorContainer__e0mN3",
  gridNameEditor: "GridDialog_gridNameEditor__1Gl3Y",
  invalidGridName: "GridDialog_invalidGridName__3sVft",
  warningMessage: "GridDialog_warningMessage__1l5N3"
}
